<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 38.008 37.51">
        <path id="flag"
              d="M29.649,13.579a1.14,1.14,0,0,0-.987-.4c-3.23.1-5.517-1.482-7.938-3.157-2.384-1.648-4.85-3.353-8.249-3.249a1.973,1.973,0,0,0-1.034.374,1.194,1.194,0,0,0-.812-1.041l-.177-.059a1.192,1.192,0,0,0-1.509.754L.061,33.438a1.194,1.194,0,0,0,.754,1.509l.177.059A1.192,1.192,0,0,0,2.5,34.252l5.268-15.8a1.275,1.275,0,0,0,.9.29c3.23-.1,5.517,1.482,7.938,3.157,2.314,1.6,4.7,3.253,7.953,3.253.1,0,.2,0,.3,0a2.081,2.081,0,0,0,1.753-1.312l1.636-4.907h0l1.5-4.5A.915.915,0,0,0,29.649,13.579ZM2.008,34.088a.672.672,0,0,1-.638.46c-.022,0-.066,0-.066,0l-.49-.173S.457,33.894.554,33.6L9.436,6.97a.672.672,0,0,1,.851-.425l.177.059a.673.673,0,0,1,.426.851ZM26.12,23.674a1.561,1.561,0,0,1-1.276.957c-3.231.1-5.517-1.482-7.938-3.157-2.384-1.648-4.849-3.353-8.249-3.249a.7.7,0,0,1-.585-.206.374.374,0,0,1-.056-.306L10.6,9.953a1.647,1.647,0,0,1,1.262-.822c3.233-.1,5.517,1.482,7.938,3.157,2.314,1.6,4.7,3.253,7.953,3.253.1,0,.2,0,.3,0a.659.659,0,0,1,.555.186.392.392,0,0,1,.059.312l-.911,2.732h0a1.56,1.56,0,0,1-1.276.957,9.6,9.6,0,0,1-3.933-.755.26.26,0,0,0-.194.482,10.215,10.215,0,0,0,3.86.8q.141,0,.283,0a1.817,1.817,0,0,0,.858-.271l-.28.839h0a1.56,1.56,0,0,1-1.276.957c-3.232.1-5.517-1.482-7.938-3.157-2.384-1.649-4.848-3.352-8.25-3.249a.26.26,0,0,0,.008.519h.008c3.229-.1,5.517,1.482,7.938,3.157,2.314,1.6,4.7,3.253,7.953,3.253.1,0,.2,0,.3,0a1.817,1.817,0,0,0,.859-.271Zm3.136-9.4-.341,1.021a1.23,1.23,0,0,0-.877-.275c-3.23.1-5.517-1.482-7.938-3.157-2.384-1.648-4.851-3.353-8.249-3.249a1.9,1.9,0,0,0-.893.278l.245-.736A1.684,1.684,0,0,1,12.49,7.3c3.23-.1,5.517,1.482,7.938,3.157,2.314,1.6,4.7,3.253,7.953,3.253.1,0,.2,0,.3,0a.66.66,0,0,1,.555.186A.4.4,0,0,1,29.256,14.27Z"
              transform="translate(-1.498 3.831) rotate(-18)" fill="#799cfb" stroke="#799cfb" stroke-width="0.5"/>
    </svg>
</template>

<script>
    export default {
        name: "IFlag",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
